import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeckHand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 461.38 460.28",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-168.2 -211.61)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m484.66 326.84s0.21788 20.085 0.21788 30.452c0 62.484-50.653 113.14-113.14 113.14s-113.14-50.653-113.14-113.14c0-10.414 9.7e-4 -30.077 9.7e-4 -30.077" }),
			/* @__PURE__ */ _jsx("path", { d: "m256.58 288.65h228.3v31.315h-228.29z" }),
			/* @__PURE__ */ _jsx("path", { d: "m225.85 235.61c76.098 0 212.25 0.71429 288.35 0.71429l-29.336 44.65h-228.29z" }),
			/* @__PURE__ */ _jsx("rect", {
				x: 285.54,
				y: 509.68,
				width: 162.14,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 285.18,
				y: 535.76,
				width: 162.14,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 289.87,
				y: 561.83,
				width: 152.04,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 303.66,
				y: 587.9,
				width: 123.76,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 315.13,
				y: 613.97,
				width: 101.53,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 340.02,
				y: 640.04,
				width: 51.026,
				height: 15
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m436.2 313.96s27.272-17.732 66.345-3.9615c39.073 13.77 20.261 43.362 54.613 55.338s66.969-11.289 66.969-11.289l-14.544 26.892 14.672 23.948s-39.868 5.3797-70.895-9.6552-26.38-50.011-46.888-64.289c-20.509-14.279-34.314-20.606-45.55-19.474-11.237 1.1324-24.721 2.4912-24.721 2.4912z",
				stroke: "#000",
				strokeWidth: "1px"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m442.17 310.91s19.527-22.835 57.114-20.854c37.587 1.9811 28.375 33.11 61.388 34.736 33.013 1.6261 55.862-27.508 55.862-27.508l-6.1366 27.621 18.72 17.375s-33.585 15.188-64.438 9.9834c-30.853-5.2048-35.363-37.399-56.821-44.684-21.458-7.2852-35.096-9.2805-44.657-5.3397-9.5603 3.9408-21.033 8.6698-21.033 8.6698z",
				stroke: "#000",
				strokeWidth: ".91629px"
			}),
			/* @__PURE__ */ _jsxs("g", {
				stroke: "#000",
				strokeWidth: "1px",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m368.71 670.52-60.609-188.9-139.4 78.792z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "m173.57 559.86c5.7143 0 190.36 103.57 190.36 103.57l-3.9286-10.357-179.29-97.5z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m182.9 554.36c5.7143 0 176.07 95 176.07 95l-3.9286-10.357-165-88.929z",
						fill: "#fff"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m370.42 241.55c-2.5977 0-4.705 2.0378-4.705 4.547 0 1.2982 0.56967 2.4668 1.4735 3.2948h-5.4215v4.7707h5.8076v13.954c-5.8073-1.2118-10.321-5.8318-11.249-11.619-0.1605 0.84371-0.24389 1.7148-0.24389 2.604 0 7.8102 6.47 14.138 14.456 14.138 7.9856 0 14.461-6.3279 14.461-14.138 0-0.75145-0.0624-1.4916-0.17783-2.2114-1.0962 5.7626-5.7627 10.301-11.671 11.325v-14.054h5.5739v-4.7707h-5.0658c0.90383-0.82798 1.4684-1.9965 1.4684-3.2948 0-2.5093-2.1073-4.547-4.705-4.547z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(-1 0 0 1 737.41 .86467)",
				stroke: "#000",
				strokeWidth: "1px",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m368.71 670.52-60.609-188.9-139.4 78.792z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "m173.57 559.86c5.7143 0 190.36 103.57 190.36 103.57l-3.9286-10.357-179.29-97.5z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m182.9 554.36c5.7143 0 176.07 95 176.07 95l-3.9286-10.357-165-88.929z",
						fill: "#fff"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", { d: "m484.66 326.84s0.21788 20.085 0.21788 30.452c0 62.484-50.653 113.14-113.14 113.14s-113.14-50.653-113.14-113.14c0-10.414 9.7e-4 -30.077 9.7e-4 -30.077" }),
			/* @__PURE__ */ _jsx("path", { d: "m256.58 288.65h228.3v31.315h-228.29z" }),
			/* @__PURE__ */ _jsx("path", { d: "m225.85 235.61c76.098 0 212.25 0.71429 288.35 0.71429l-29.336 44.65h-228.29z" }),
			/* @__PURE__ */ _jsx("rect", {
				x: 285.54,
				y: 509.68,
				width: 162.14,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 285.18,
				y: 535.76,
				width: 162.14,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 289.87,
				y: 561.83,
				width: 152.04,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 303.66,
				y: 587.9,
				width: 123.76,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 315.13,
				y: 613.97,
				width: 101.53,
				height: 15
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 340.02,
				y: 640.04,
				width: 51.026,
				height: 15
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m436.2 313.96s27.272-17.732 66.345-3.9615c39.073 13.77 20.261 43.362 54.613 55.338s66.969-11.289 66.969-11.289l-14.544 26.892 14.672 23.948s-39.868 5.3797-70.895-9.6552-26.38-50.011-46.888-64.289c-20.509-14.279-34.314-20.606-45.55-19.474-11.237 1.1324-24.721 2.4912-24.721 2.4912z",
				stroke: "#000",
				strokeWidth: "1px"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m442.17 310.91s19.527-22.835 57.114-20.854c37.587 1.9811 28.375 33.11 61.388 34.736 33.013 1.6261 55.862-27.508 55.862-27.508l-6.1366 27.621 18.72 17.375s-33.585 15.188-64.438 9.9834c-30.853-5.2048-35.363-37.399-56.821-44.684-21.458-7.2852-35.096-9.2805-44.657-5.3397-9.5603 3.9408-21.033 8.6698-21.033 8.6698z",
				stroke: "#000",
				strokeWidth: ".91629px"
			}),
			/* @__PURE__ */ _jsxs("g", {
				stroke: "#000",
				strokeWidth: "1px",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m368.71 670.52-60.609-188.9-139.4 78.792z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "m173.57 559.86c5.7143 0 190.36 103.57 190.36 103.57l-3.9286-10.357-179.29-97.5z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m182.9 554.36c5.7143 0 176.07 95 176.07 95l-3.9286-10.357-165-88.929z",
						fill: "#fff"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m370.42 241.55c-2.5977 0-4.705 2.0378-4.705 4.547 0 1.2982 0.56967 2.4668 1.4735 3.2948h-5.4215v4.7707h5.8076v13.954c-5.8073-1.2118-10.321-5.8318-11.249-11.619-0.1605 0.84371-0.24389 1.7148-0.24389 2.604 0 7.8102 6.47 14.138 14.456 14.138 7.9856 0 14.461-6.3279 14.461-14.138 0-0.75145-0.0624-1.4916-0.17783-2.2114-1.0962 5.7626-5.7627 10.301-11.671 11.325v-14.054h5.5739v-4.7707h-5.0658c0.90383-0.82798 1.4684-1.9965 1.4684-3.2948 0-2.5093-2.1073-4.547-4.705-4.547z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(-1 0 0 1 737.41 .86467)",
				stroke: "#000",
				strokeWidth: "1px",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m368.71 670.52-60.609-188.9-139.4 78.792z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "m173.57 559.86c5.7143 0 190.36 103.57 190.36 103.57l-3.9286-10.357-179.29-97.5z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m182.9 554.36c5.7143 0 176.07 95 176.07 95l-3.9286-10.357-165-88.929z",
						fill: "#fff"
					})
				]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgDeckHand);
export { ForwardRef as ReactComponent };
